import "src/pages/DataStudio/Dashboard/styles_vanilla.css.ts.vanilla.css!=!../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/pages/DataStudio/Dashboard/styles_vanilla.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA8VXbW-kNhD-nl9h6RRdIoWVzQK7S9QvVTf_oaqqyhh71wnYFMyGpOp_r3jxYoPZ46SebpMoCcwz88yLZ8abv5DMLigNIfjnDoACpykXpxj4QdE83wGQ48Z756k6xwD5EOqH5YmLGECAayWf7_6922g1qFPTC3iJVErmWpkh5XdSKa-KDH_E4FTytNXb_vYUzYsMK-oRmdW5qGJQ0oJi9dDa8hhXTyDnIsfNgx_ConkCiJWPjx0cFzFAkclxmcL2f6EQwEUKhq2gs5Vg8nYqZS3SGHxhOxaxsIUkskxp6ZU45XUVg31P_5qI4IY7Bn-W0eZKYHip8wbhvUUn7Oi0iBigZ4tZ67EsW37dZ-QXA1Q0oJIZT8EXGtKAwhXk90VzTYiijfJwxk8iBoQKRcv2KanLqjVYSK4fqRKLiisuRQxwlgG48StAcUXbl0wK5b1TfjqrGISwI6E5hzBgAbFdjc_yQstJ_Ecvp1nQL0hEQgJtVX-kWGEPE8Uv9Jevqqzp1z8XFU_Cd32BIgwxMVlDtDvsDzPfImibj_qktSIV_6Ttcezj6orIJC3BvKb6VBn6d0uuHLcv_stvFuN95B9sdvtF9P4lPO4tNIxQQC30YQn98nL89Xg00UmEyBZbaLyIDtsvE73zdyiybSdLaB8ihsi0nJeja6Ymsg6gP-DOQ5L0_7PD250OjyuaV-YZea0rxdmHR6RQVKjxleEG6dzoTv-s1aWunqw5uoqXUJKShbPPKCGHwNJPp_0k50IPja2eGYXUZ7qkGW7PkKWD9ePnKoSTSma16s58Rpka613Joq3z-2urYLLM4_7Ptmn__uCF8L7rxp8eF-nAyrB16mxZ3XHSs_RPAM2Mr-uBjnIYHslaZVzQGAgp6Df6rkk3ZpLUVV-n7m5iSJ_tOb7XR_1nOGFVAuqDaVL9Lse4IWc5gSlOMXE4ca2YWwPFVZcAtEODZfI9Bhde8SSjz_PlyORmjhnbkySiAY16do1XnXHaaoVdD24JgvKU4Af4BIbvDQofLd2vlt_-6Pc4Sn6a368_0O-35a5lSGWzsbh3jMXIXhR0azf05C5rg6p-qfMnlsUPHshylf_F2Pfdi-8U8PcqteViOAyhytVH9ZDbL48XnyHKlqMy1uCZpykVDqemTFTHRJvWVMz671gCuNnqE2Cga5cfDuKOzeViQheBhG6DbWQB31cBYfexgM3aXfa7Gv28EleX9pSrc6dfu-qYvUIPmMnEMWLxYVZp2bMaHLoRwc8exYV3XcjgdDQhuCS0dMdD_c3XfcsxbtHB3JZ_az8bMuP1S9C08FFgYrvVaM4sXHUnR9GqzoB29rZnvupvATeWbXQYg2TsbgQXXOGMf06ksVOfqwxNVGKhxjX-5vUKkUkjNd-ZC3QMJkC6HA9mMcFwCxF1dLNZJk5OnClxvq25KwRzh2M459lHDHIpZFVgMlHH17R79PrN9L5ZEvpma0pktsS8o6LcknDc95BYV8_SjtGwJZoShdvUfxgrzioUEwAA\"}!../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var capitalizeText = '_1olv1d519';
export var containerStyle = '_1olv1d50';
export var customTabStyle = '_1olv1d55';
export var detailsButton = '_1olv1d5x';
export var detailsButtonIcon = '_1olv1d5y';
export var errorContainer = '_1olv1d510';
export var errorMaxWidth = '_1olv1d511';
export var errorTitle = '_1olv1d51p';
export var headerGap = '_1olv1d5c';
export var headerIcon = '_1olv1d5b';
export var headerStyle = '_1olv1d51';
export var headerTitle = '_1olv1d51d';
export var importJobsCard = '_1olv1d515';
export var importJobsTitle = '_1olv1d516';
export var jobCard = '_1olv1d5i';
export var jobCardFlexContainer = '_1olv1d517';
export var jobCardHeader = '_1olv1d5k';
export var jobCardHighlighted = '_1olv1d5j';
export var jobCardTitle = '_1olv1d5l';
export var jobCardTitleGap = '_1olv1d5m';
export var jobMetadata = '_1olv1d5o';
export var jobMetadataRow = '_1olv1d5p';
export var jobMetadataText = '_1olv1d518';
export var jobProgress = '_1olv1d5q';
export var jobProgressBar = '_1olv1d5s';
export var jobProgressFill = '_1olv1d5t';
export var jobProgressFillCompleted = '_1olv1d5u';
export var jobProgressFillDefault = '_1olv1d5w';
export var jobProgressFillFailed = '_1olv1d5v';
export var jobProgressHeader = '_1olv1d5r';
export var jobProgressPercentage = '_1olv1d51b';
export var jobProgressText = '_1olv1d51a';
export var jobTag = '_1olv1d5n';
export var jobsCountInfo = '_1olv1d514';
export var jobsGridStyle = '_1olv1d53';
export var loadingContainer = '_1olv1d5z';
export var metadataWarningCard = '_1olv1d5d';
export var noJobsCard = '_1olv1d513';
export var noJobsText = '_1olv1d51j';
export var noJobsTitle = '_1olv1d51i';
export var searchContainer = '_1olv1d5e';
export var searchFiltersCard = '_1olv1d51n';
export var searchIcon = '_1olv1d5f';
export var searchInput = '_1olv1d5g';
export var selectInput = '_1olv1d5h';
export var sortIndicator = '_1olv1d512';
export var sortIndicatorText = '_1olv1d51o';
export var statsActiveText = '_1olv1d51k';
export var statsCompletedText = '_1olv1d51l';
export var statsFailedText = '_1olv1d51m';
export var statsGridStyle = '_1olv1d52';
export var statusTag = '_1olv1d56';
export var statusTagCompleted = '_1olv1d58';
export var statusTagDefault = '_1olv1d5a';
export var statusTagFailed = '_1olv1d59';
export var statusTagInProgress = '_1olv1d57';
export var tabsContainerStyle = '_1olv1d54';
export var timestampRow = '_1olv1d51c';
export var warningCardContent = '_1olv1d51e';
export var warningErrorText = '_1olv1d51h';
export var warningText = '_1olv1d51g';
export var warningTitle = '_1olv1d51f';